const { useState, useEffect, useRef } = React;

export function useAnswerSelection(feed, topic, view, pause) {
  const [selection, setSelection] = useState(null);
  const pauseRef = useRef(pause); pauseRef.current = pause;
  useEffect(() => {
    let timer;
    setSelection(null);
    const clear = () => { clearTimeout(timer); setSelection(null); };
    const inspect = () => {
      const selected = window.getSelection();
      if (!selected?.rangeCount || selected.isCollapsed) return clear();
      const range = selected.getRangeAt(0);
      const element = node => node.nodeType === 1 ? node : node.parentElement;
      const start = element(range.startContainer), end = element(range.endContainer);
      const answer = start?.closest('.ai-answer');
      if (!answer || !feed.current?.contains(answer) || !answer.contains(end) || start.closest('button,input,textarea,select') || end.closest('button,input,textarea,select')) return clear();
      const text = selected.toString().trim(); if (!text) return clear();
      const rect = range.getBoundingClientRect(), bounds = feed.current.getBoundingClientRect();
      if (rect.bottom < bounds.top || rect.top > bounds.bottom || !rect.width) return clear();
      pauseRef.current();
      setSelection({ text: Array.from(text).slice(0, 1200).join(''), truncated: Array.from(text).length > 1200,
        turnId: answer.closest('[data-turn-id]')?.dataset.turnId,
        x: Math.max(96, Math.min(innerWidth - 96, rect.left + rect.width / 2)),
        y: rect.top >= bounds.top + 48 ? rect.top - 46 : Math.min(innerHeight - 56, rect.bottom + 10) });
    };
    const schedule = () => { clearTimeout(timer); timer = setTimeout(inspect, 140); };
    const outside = event => { if (!event.target.closest('.ai-selection-action')) clear(); };
    const key = event => { if (event.key === 'Escape') clear(); };
    document.addEventListener('selectionchange', schedule);
    document.addEventListener('pointerup', schedule);
    document.addEventListener('pointerdown', outside);
    document.addEventListener('keydown', key);
    window.addEventListener('scroll', clear, true);
    window.addEventListener('resize', clear);
    window.addEventListener('blur', clear);
    return () => {
      clearTimeout(timer);
      document.removeEventListener('selectionchange', schedule); document.removeEventListener('pointerup', schedule);
      document.removeEventListener('pointerdown', outside); document.removeEventListener('keydown', key);
      window.removeEventListener('scroll', clear, true); window.removeEventListener('resize', clear); window.removeEventListener('blur', clear);
    };
  }, [feed, topic, view]);
  return [selection, () => setSelection(null)];
}
